import { stopEvent } from '@/utils/tools'
import { openConfirmModal, Tag } from '@gate/gui'
import { OverflowHideStyled } from '../Action/style'
import { FC } from 'react'
import { useRouter } from 'next/router'
import { useTranslation } from 'next-i18next'
import { Flex } from '@mantine/core'

const FundraisingTags: FC<{ detail: any[] }> = props => {
  const { locale } = useRouter()
  const { t } = useTranslation()

  console.log('props=========》', props)

  const onClick = () => {
    openConfirmModal({
      styles: {
        header: {
          marginBottom: '24px',
        },
        body: {
          '.mantine-Group-root': {
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            gap: '24px',
          },
          '.mantine-Button-root': {
            marginTop: '16px',
            borderRadius: '18px',
          },
          '.mantine-Group-root .mantine-UnstyledButton-root:first-of-type': {
            display: 'none',
          },
          '.mantine-Group-root .mantine-UnstyledButton-root:nth-of-type(2)': {
            width: '100%',
          },
        },
      },
      radius: 8,
      padding: 24,
      centered: true,
      children: (
        <OverflowHideStyled gap={12} align="center" wrap={'wrap'} dir={locale === 'ar' ? 'rtl' : undefined}>
          {props?.detail?.map((item: any, index: number) => (
            <Tag
              bg="var(--color-cmpt-11)"
              color="var(--color-text-2)"
              key={'tag' + item?.key + index}
              label={item?.key}
            />
          ))}
        </OverflowHideStyled>
      ),
      title: <span className="text-1 size-24 font-500">{t('p.tags', { ns: 'fundraising' })}</span>,
      labels: { cancel: false, confirm: `${t('p.got.it', { ns: 'fundraising' })}` },
    })
  }

  return (
    <Flex
      //
      // style={{ maxHeight: '54px', overflow: 'hidden' }}
      w={'max-content'}
      maw={248}
      wrap={'wrap'}
      align="center"
      gap={4}
      onClick={e => {
        stopEvent(e)
        if (props?.detail?.slice(4)?.length) {
          onClick()
        }
      }}
    >
      {props?.detail?.slice(0, 4)?.length ? '' : '--'}
      {props?.detail
        ?.slice(0, 4)
        ?.map((item: any, index: number) => (
          <Tag
            bg="var(--color-cmpt-11)"
            color="var(--color-text-2)"
            key={'tag' + item?.key + index}
            label={item?.key}
          />
        ))}

      {props?.detail?.slice(4)?.length ? (
        <div
          onClick={e => {
            stopEvent(e)
            onClick()
          }}
          // onMouseEnter={onClick}
        >
          <Tag bg="var(--color-cmpt-15)" color="var(--color-text-5)" label={`+${props?.detail?.slice(4)?.length}`} />
        </div>
      ) : (
        ''
      )}
    </Flex>
  )
}

export default FundraisingTags
